import pkg from '../../../package.json' with { type: 'json' };
import type { CommonApiConfig } from './apiConfigTypes';

export const apiCommonConfig: CommonApiConfig = {
  apiKey: 'sVMTVogE67faKqBLOlZBVoYuay2FquzW',
  appVersion: pkg.version,
  platform: 'web',
  isLogEnabled: process.env.NEXT_PUBLIC_ENABLE_API_LOGGING === 'true',
  isLogResponseHeadersEnabled: process.env.NEXT_PUBLIC_ENABLE_API_LOGGING_RESPONSE_HEADERS === 'true',
};
